import React from 'react';

import { Quantity } from 'src/components/atoms/Quantity/Quantity';

export interface ProductOptionsDispatchProps {
  onChangeQuantity: (payload: { quantity: number; valid: boolean }) => void;
}

export interface ProductOptionsStateProps {
  inStock: boolean;
  quantity: number;
}

type ProductOptionsProps = ProductOptionsDispatchProps & ProductOptionsStateProps;

export const ProductOptions = ({ inStock, onChangeQuantity, quantity }: ProductOptionsProps) => {
  if (!inStock) {
    return null;
  }

  return (
    <Quantity
      defaultValue={quantity}
      onChange={(quantity, valid) => {
        onChangeQuantity({ quantity, valid });
      }}
    />
  );
};
